
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import Axios from 'axios';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';
import TvModule from '@/stores/modules/TvModule';
import NevronSearch from '../../../components/NevronSearch.vue';
import NevronSearchNoResults from '../../../components/NevronSearchNoResults.vue';
import axiosInstance from '@/helpers/axios';
import SeriesModule from '@/stores/modules/Series';

@Component({
  components: {
    SweetModal,
    vPagination,
    NevronSearch,
    NevronSearchNoResults,
  },
  mixins: [ Clickaway ],
})

export default class AttachItemToPackage extends Vue {

  @Prop()
  module!: SeriesModule;

  response: any = null;
  items: any = null;
  indexList: number[] = [];
  searchQuery: string = '';
  allChecked = false;

  mounted() {
    this.fetchData();
  }

  save() {
    this.$emit('save', this.indexList);
    this.cancel();
  }

  cancel() {
    this.indexList = [];
    this.allChecked = false;
    // @ts-ignore
    this.$children[0].close();
  }

  @Watch('response.currentPage')
  ChangedPage() {
    this.fetchData(this.response.currentPage);
  }

  fetchData(index = 1) {
    return this.module.fetchSeries(index, this.searchQuery, 10)
      .then((response) => {
        this.response = response;
        this.items = this.response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  checkAll() {
    if (!this.allChecked) {
      this.indexList = [];
      for (const iterator of this.items) {
        if (iterator.id) {
          this.indexList.push(iterator.id);
        }
      }
      this.allChecked = true;
    } else {
      this.indexList = [];
      this.allChecked = false;
    }
  }

  updateCheck() {
    if (this.indexList.length === this.items.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false ;
    }
  }
}
